let _iosLabel: HTMLLabelElement | null = null;

// Lazily create a persistent hidden switch element for the iOS 18+ haptic trick.
// The label stays in the DOM so repeated taps don't churn allocations.
function getIosLabel(): HTMLLabelElement {
  if (!_iosLabel) {
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.setAttribute('switch', '');

    const label = document.createElement('label');
    const style = 'position:fixed;opacity:0;pointer-events:none;width:0;height:0;overflow:hidden;';
    input.style.cssText = style;
    label.style.cssText = style;
    label.appendChild(input);
    document.body.appendChild(label);
    _iosLabel = label;
  }
  return _iosLabel;
}

export function haptic(): void {
  if (typeof navigator === 'undefined') return;

  // Android / Chrome — Vibration API
  if ('vibrate' in navigator) {
    navigator.vibrate(10);
    return;
  }

  // iOS 18+ — toggling a hidden <input type="checkbox" switch> emits haptic feedback
  getIosLabel().click();
}
